import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    redirect: '/home',
    component: () => import('../layout/index.vue'),
    children: [
      {
          path: "/home",
          component: () => import('../views/Home.vue')
      },
      {
          path: "/CLCCertification",
          component: () => import('../views/CLC/certification.vue')
      },
      {
        path: "/news",
        component: () => import('../views/news/news.vue')
      },
      {
        path: "/newsDetail",
        component: () => import('../views/news/newsDetails.vue')
      },
      {
        path: "/product",
        component: () => import('../views/product/index.vue')
      },
      {
        path: "/contact",
        component: () => import('../views/contact/index.vue')
      },
      {
        path: "/afterSale",
        component: () => import('../views/afterSale/index.vue')
      },
      {
        path: "/talentRecruitment",
        component: () => import('../views/talentRecruitment/index.vue')
      },
      {
          path: "/registration",
          component: () => import('../views/registration/index.vue')
      },
      {
          path: "/login",
          component: () => import('../views/login/index.vue')
      },
      {
          path: "/instructions",
          component: () => import('../views/instructions/index.vue')
      },
      {
          path: "/cases",
          component: () => import('../views/cases/case.vue')
      },
      {
          path: "/caseDetail",
          component: () => import('../views/cases/caseDetail.vue')
      },
      {
          path: "/productDetail",
          component: () => import('../views/products/productDetail.vue')
      },
      {
          path: "/zhuoran",
          component: () => import('../views/zhuoranDigital/zhuoran.vue')
      },
      {
        path: "/recruitment",
        component: () => import('../views/recruitment/index.vue')
      },
      {
        path: "/message",
        component: () => import('../views/message/index.vue')
      },
      {
        path: "/talent",
        component: () => import('../views/talent/index.vue')
      },
      {
        path: "/about",
        component: () => import('../views/about/index.vue')
      },
      {
        path: "/place/order",
        component: () => import('../views/zhuoranDigital/placeOrders.vue')
      },
      {
        path: "/orderDetails",
        component: () => import('../views/orderDetails/index.vue')
      },
      {
        path: "/order",
        component: () => import('../views/order/index.vue')
      },
      {
        path: "/medicalRecords",
        component: () => import('../views/zhuoranDigital/medicalRecords.vue')
      },
      {
            path: "/agreement",
            component: () => import('../views/user/agreement.vue')
        },
        {
            path: "/password",
            component: () => import('../views/user/password.vue')
        },
        {
            path: "/address",
            component: () => import('../views/user/address.vue')
        }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    if (!localStorage.getItem('token') && to.path === '/zhuoran') {
        next({ path:'/login'})
    }else{
        next()
    }
}
)

export default router
